module.exports = __webpack_public_path__ + "r-v3/img/gooroomee_study_download_image3.38c76db9.png";